<template>
  <div class="row w-100">
    <div
      v-for="(elem, iter) in listElements"
      :key="elem.name"
      class="text-left d-flex flex-column"
      :class="iter === 0 ? 'col-12 col-md-6' : 'col-6 col-md-3'"
    >
      <label
        :for="`card-${elem.name}`"
        class="text-secondary my-2"
      > {{ elem.label }} </label>
      <div :id="`card-${elem.name}`" />
    </div>
    <div
      v-for="(elem) in listElements"
      :key="elem.name + 'error'"
      class="col-12"
    >
      <transition
        tag="div"
        @enter="tf_slideDown"
        @leave="tf_slideUp"
      >
        <div
          v-if="elem.event.error !== undefined"
          :id="`card-${elem.name}-error`"
          class="animated mt-1"
        >
          <small
            role="alert"
            class="text-danger"
            v-text="elem.event.error.message"
          />
        </div>
      </transition>
    </div>
    <div class="col-12">
      <v-loader
        id="stripe_submit"
        :next="payment"
        :title="`Payer ${format(price)} €`"
        icon="arrow-white-right"
        class="mt-3 w-100 mb-1"
      />
    </div>
    <transition
      tag="div"
      @enter="tf_slideDown"
      @leave="tf_slideUp"
    >
      <div
        v-if="error !== null"
        class="col-12 mt-1"
      >
        <div class="text-danger text-center">
          {{ error }}
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { pick } from 'lodash-es';
import { mapGetters } from 'vuex';
import { transform } from '@/mixins';
import { formatPrice } from '@/utils/_Number';

import list from '@/assets/data/listElements.json';

export default {
  name: 'CreditCard',
  mixins: [transform],
  props: {
    price: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data() {
    return {
      stripe: {},
      listElements: list.listElements,
      error: null,
      setted: false,
      showDetails: false,
    };
  },
  computed: {
    ...mapGetters({
      transaction: 'checkout/transaction',
    }),
    cardNumber() {
      return 'XXXX XXXX XXXX XXXX';
    },
  },
  watch: {
    transaction: {
      deep: true,
      handler(value) {
        if (value && !this.setted) {
          this.stripe = window.Stripe(import.meta.env.VITE_STRIPE_KEY);
          this.setContainer();
        }
      },
    },
  },
  mounted() {
    if (this.transaction && this.transaction.id) {
      this.stripe = window.Stripe(import.meta.env.VITE_STRIPE_KEY);
      this.setContainer();
      this.setted = true;
    }
  },
  beforeDestroyed() {
    this.unsetContainer();
  },
  methods: {
    cardName: (elem) => `card-${elem.name}`,
    unsetContainer() {
      this.listElements.forEach((elem) => {
        const id = this.cardName(elem);
        const shadow = elem;
        document.getElementById(id).removeEventListener('change',
          (event) => { shadow.event = event; });
        shadow.destroy();
      });
    },
    setContainer() {
      const { stripe } = this;
      if (stripe) {
        const elements = stripe.elements();
        this.listElements.forEach((elem) => {
          const newElem = elements.create(`card${elem.name}`,
            pick(elem, ['style', 'placeholder', 'classes']));
          newElem.mount(`#${this.cardName(elem)}`);
          newElem.addEventListener('change', (event) => {
            Object.assign(elem, { event });
          });
          Object.assign(elem, { container: newElem });
        });
      }
    },
    async payment() {
      const { stripe } = this;
      const { container } = this.listElements[0];
      try {
        await this.$store.dispatch('checkout/payment', [stripe, container]);
        this.$store.dispatch('analytics/purchase');
        this.$emit('payment:success');
      } catch (err) {
        this.error = 'Erreur, veuillez réessayer ultérieurement';
      }
    },
    format: (price) => formatPrice(price, true),
  },
};
</script>
